'use client';

import { useReportWebVitals } from 'next/web-vitals';

export function WebVitals() {
  useReportWebVitals((metric) => {
    // FEAT-RUM-02: web-vitals KIRIM ke sink nyata (bukan sekedar console.log)
    fetch('/api/analytics', {
      method: 'POST',
      body: JSON.stringify({
        event: 'web-vitals',
        metric: metric.name,
        value: metric.value,
        id: metric.id,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  });

  return null;
}
